import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

interface PageTransitionProps {
  children: React.ReactNode;
}

/**
 * Page transition wrapper with fade and slide animation
 * Also handles scroll-to-top on route change
 */
export function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <motion.div
      key={location.pathname}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{
        duration: 0.3,
        ease: [0.25, 0.1, 0.25, 1],
      }}
    >
      {children}
    </motion.div>
  );
}
